var _path, _path2, _path3, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _path4, _path5, _circle11, _path6, _circle12, _path7, _circle13, _circle14, _circle15, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndrawSearchingEverywhereTffi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 881.753,
    height: 800,
    viewBox: "0 0 881.753 800",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-649.896 -305.824)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1067.947,497.383c-63.182-47.234-162.14-91.9-271.5-122.556-99.573-27.909-196.693-41.384-273.491-37.943l-.4-8.931c77.713-3.48,175.841,10.108,276.3,38.266,110.38,30.938,210.411,76.136,274.441,124Z",
    transform: "translate(339.007 182.878)",
    fill: "#3f3d56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1093.719,584.883a297.5,297.5,0,0,1-25.747,121.465q-2.132,4.8-4.443,9.512A298.632,298.632,0,0,1,496.541,584.883q0-10.366.706-20.57.335-5.189.867-10.316c16.444-158.045,153.78-275.53,312.465-267.3s283.132,139.289,283.14,298.188Z",
    transform: "translate(306.675 131.76)",
    fill: "#f2f2f2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1067.581,558q-2.132,4.8-4.443,9.512-13.088,1.421-27.552,2.065c-7.983.358-16.2.536-24.594.536-73.324,0-161.569-13.535-251.718-38.8C658.809,503.155,567.918,463.766,503.337,420.4q-3.3-2.213-6.481-4.434.335-5.189.867-10.316,5.136,3.661,10.594,7.33c63.821,42.849,153.8,81.817,253.372,109.727,89.362,25.049,176.776,38.468,249.259,38.468q12.431,0,24.236-.528Q1052.375,559.869,1067.581,558Z",
    transform: "translate(307.067 280.108)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1056.627,659.9c-73.322,0-161.572-13.534-251.717-38.8-100.464-28.158-191.359-67.549-255.941-110.914-65.93-44.271-96.845-87.893-87.053-122.832s58.877-56.138,138.211-59.694l.4,8.931c-37.048,1.66-67.241,7.167-89.739,16.367-22.444,9.177-35.99,21.562-40.264,36.809s.863,32.868,15.268,52.373c14.44,19.553,37.372,39.949,68.161,60.624,63.814,42.85,153.8,81.82,253.37,109.729,89.364,25.047,176.77,38.469,249.26,38.471q12.424,0,24.231-.528c37.049-1.661,67.241-7.167,89.74-16.367,22.443-9.177,35.99-21.561,40.264-36.809,7.673-27.378-15.516-62.952-65.3-100.169l5.354-7.16c25.617,19.152,44.58,38.029,56.363,56.108,12.631,19.382,16.732,37.427,12.19,53.633-9.793,34.939-58.878,56.137-138.211,59.693C1073.231,659.72,1065.021,659.9,1056.627,659.9Z",
    transform: "translate(261.434 183.174)",
    fill: "#3f3d56"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.422,
    cy: 3.422,
    r: 3.422,
    transform: "translate(1106.282 357.36)",
    fill: "#f2f2f2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.886,
    cy: 5.886,
    r: 5.886,
    transform: "translate(649.896 500.903)",
    fill: "#ccc"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.628,
    cy: 11.628,
    r: 11.628,
    transform: "translate(711.291 728.966)",
    fill: "#3E629C"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.75,
    cy: 7.75,
    r: 7.75,
    transform: "translate(1333.481 373.561)",
    fill: "#ccc"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.583,
    cy: 12.583,
    r: 12.583,
    transform: "translate(1457.486 520.401)",
    fill: "#ccc"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.399,
    cy: 5.399,
    r: 5.399,
    transform: "translate(1512.3 496.591)",
    fill: "#ccc"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.422,
    cy: 8.422,
    r: 8.422,
    transform: "translate(853.79 424.212)",
    fill: "#3E629C"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.399,
    cy: 5.399,
    r: 5.399,
    transform: "translate(1493.407 672.044)",
    fill: "#ccc"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.719,
    cy: 6.719,
    r: 6.719,
    transform: "translate(1015.302 390.045)",
    fill: "#ccc"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.277,
    cy: 7.277,
    r: 7.277,
    transform: "translate(1116.822 305.824)",
    fill: "#3E629C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M418.008,357.824H408.99V348.81h-4.836v9.014h-9.016v4.838h9.016v9.016h4.836v-9.016h9.018Z",
    transform: "matrix(0.616, -0.788, 0.788, 0.616, 150.33, 739.965)",
    fill: "#ccc"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M507.6,335.987h-6.74v-6.74h-3.62v6.74H490.5v3.62h6.74v6.74h3.62v-6.74h6.74Z",
    transform: "translate(1024.051 501.8)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 25.091,
    cy: 25.091,
    r: 25.091,
    transform: "translate(888.445 641.369)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.091,
    cy: 25.091,
    r: 25.091,
    transform: "translate(1165.591 893.423)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.091,
    cy: 25.091,
    r: 25.091,
    transform: "translate(1081.19 680.147)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.091,
    cy: 25.091,
    r: 25.091,
    transform: "translate(900.991 818.149)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.091,
    cy: 25.091,
    r: 25.091,
    transform: "translate(1215.77 545.566)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.091,
    cy: 25.091,
    r: 25.091,
    transform: "translate(1299.027 715.503)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.075,
    cy: 33.075,
    r: 33.075,
    transform: "translate(1207.789 432.655)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M717.583,286.191a46.761,46.761,0,0,0-46.761,46.761c0,25.825,46.761,110.63,46.761,110.63s46.761-84.8,46.761-110.63a46.761,46.761,0,0,0-46.761-46.761Zm0,69.571a21.67,21.67,0,1,1,21.67-21.67,21.67,21.67,0,0,1-21.67,21.67Z",
    transform: "translate(523.281 131.638)",
    fill: "#3E629C"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.075,
    cy: 33.075,
    r: 33.075,
    transform: "translate(880.332 522.37)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M571.582,326.191a46.761,46.761,0,0,0-46.761,46.761c0,25.825,46.761,110.63,46.761,110.63s46.761-84.8,46.761-110.63a46.761,46.761,0,0,0-46.761-46.761Zm0,69.571a21.67,21.67,0,1,1,21.67-21.67,21.67,21.67,0,0,1-21.67,21.67Z",
    transform: "translate(341.824 181.353)",
    fill: "#3E629C"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.075,
    cy: 33.075,
    r: 33.075,
    transform: "translate(1295.26 598.627)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M756.583,360.191a46.761,46.761,0,0,0-46.761,46.761c0,25.825,46.761,110.63,46.761,110.63s46.761-84.8,46.761-110.63a46.761,46.761,0,0,0-46.761-46.761Zm0,69.571a21.67,21.67,0,1,1,21.67-21.67,21.67,21.67,0,0,1-21.67,21.67Z",
    transform: "translate(571.752 223.61)",
    fill: "#3E629C",
    style: {
      isolation: "isolate"
    }
  }), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.075,
    cy: 33.075,
    r: 33.075,
    transform: "translate(734.547 764.598)",
    fill: "#fff"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.735,
    cy: 10.735,
    r: 10.735,
    transform: "translate(1356.781 966.786)",
    fill: "#3E629C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M786.632,577a21.47,21.47,0,1,1-42.245,7.69h0l-.008-.042c-2.112-11.668,6.909-15.8,18.577-17.909S784.52,565.333,786.632,577Z",
    transform: "translate(614.32 479.16)",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M785.81,474.819a99.219,99.219,0,1,0,5.625,146.532l121.7,102.694a9.143,9.143,0,1,0,11.806-13.964l-.014-.011-121.7-102.694A99.225,99.225,0,0,0,785.81,474.819Zm-7.846,122.667a74.336,74.336,0,1,1-8.875-104.751h0a74.336,74.336,0,0,1,8.874,104.751Z",
    transform: "translate(466.683 379.618)",
    fill: "#3E629C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawSearchingEverywhereTffi);
export default __webpack_public_path__ + "static/media/undraw_searching-everywhere_tffi.877deeac21377d65fdf731afba9e6f8c.svg";
export { ForwardRef as ReactComponent };